export default {
      id: "radio-on-color-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "svgsprite.svg#radio-on-color",
      toString: function () {
        return this.url;
      }
    }